var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopupInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.3335C52.9095 68.3335 67.8333 53.4097 67.8333 35.0003C67.8333 16.5908 52.9095 1.66699 34.5 1.66699C16.0906 1.66699 1.16675 16.5908 1.16675 35.0003C1.16675 53.4097 16.0906 68.3335 34.5 68.3335Z",
    stroke: "#E22A1F",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5013 23.5847C36.7007 23.5847 38.4836 21.8018 38.4836 19.6024C38.4836 17.403 36.7007 15.6201 34.5013 15.6201C32.302 15.6201 30.519 17.403 30.519 19.6024C30.519 21.8018 32.302 23.5847 34.5013 23.5847Z",
    fill: "#E22A1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0386 28.4521H30.8853V54.3813H38.0386V28.4521Z",
    fill: "#E22A1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupInfoIcon);
export default __webpack_public_path__ + "static/media/popup_info_icon.be5a2c03.svg";
export { ForwardRef as ReactComponent };